import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AvatarComponent } from '@shared/components/avatar/avatar.component';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';

export interface UserData {
  me: boolean;
  firstName: string;
  lastName: string;
}
@Component({
  selector: 'app-table-avatar',
  standalone: true,
  imports: [AvatarComponent],
  templateUrl: './table-avatar.component.html',
  styleUrl: './table-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableAvatarComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    readonly context: { $implicit: UserData },
  ) {}

  get data(): UserData {
    return this.context.$implicit;
  }
}
